import { Text, Flex } from '@chakra-ui/react';
import { DestroyIcon } from '@halo/ui-chat-react';
import { MyTrans } from '@halo/ui-react';
import { useTranslation } from 'react-i18next';

export function MessageDestroyTip() {
  const { t } = useTranslation();
  return (
    <Flex
      className="MessageDestroyTip fadeIn"
      p="3"
      alignItems="center"
      lineHeight="16px"
      mx="auto"
      bg="white"
      borderRadius="md"
      textAlign="center"
      fontSize="xs"
      color="fg"
      fontWeight="medium"
    >
      <DestroyIcon style={{ display: 'inline-block', marginRight: '6px' }} />
      <Text as="span">
        <MyTrans
          i18nKey="chat.messagesSelfDestructText"
          components={{ component: <Text as="span" fontWeight="semibold" /> }}
          values={{
            time: t('chat.messagesSelfDestructTime'),
          }}
        />
      </Text>
    </Flex>
  );
}
